<template>
  <div>
    <a-form class="iotplt-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="SN">
            <a-input
              v-decorator="['sn', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="订单编号">
            <a-input
              v-decorator="['order_no', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="CPE型号">
            <a-select
              v-decorator="['cpe_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingModelOptions"
            >
              <a-select-option
                v-for="opt in modelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="通信制式">
            <a-select
              v-decorator="['comm_mode_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCommModeOptions"
            >
              <a-select-option
                v-for="opt in commModeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findCustomerCpeModelOptions } from '@/api/cpe'

export default {
  name: 'SearchCpe',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'cpe_search' }),
      modelOptions: [],
      commModeOptions: [],
      loadingModelOptions: false,
      loadingCommModeOptions: false
    }
  },
  created() {
    this.fetchModelOptions()
    this.fetchCommModeOptions()
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }
      return this.$store.getters.userAgentId
    }
  },
  methods: {
    fetchModelOptions() {
      this.loadingModelOptions = true
      findCustomerCpeModelOptions({ agent_id: this.agentId }).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data
        }
        this.loadingCommModeOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values)
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
